import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';
import { useEffect, useState } from 'react';

const PricingPage = () => {
  const [activeTab, setActiveTab] = useState('moving');
  const [showScrollTop, setShowScrollTop] = useState(false);

  // SEO 優化
  useEffect(() => {
    // 設定頁面標題
    document.title = '新北搬家費用價格表【建鈞精緻搬家】台北桃園搬家價格｜廢棄物清運費用｜垃圾處理收費標準';
    
    // 更新 meta 描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '建鈞精緻搬家提供透明公開的新北搬家費用、台北搬家價格、廢棄物清運費用標準。雙邊電梯優惠價3000元起，無電梯搬家3000-5000元，垃圾清運500元起，人力搬工800元/時。24小時免費估價諮詢：0978-900-081');
    }
    
    // 更新 meta 關鍵字
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '新北搬家費用,台北搬家價格,搬家費用計算,搬家價格表,廢棄物清運費用,垃圾清運價格,人力搬工費用,搬家收費標準,板橋搬家費用,新莊搬家價格,中和搬家費用,永和搬家價格,搬家估價,免費估價,搬家報價,建鈞搬家');
    }

    // 监聽滾動顯示返回頂部按鈕
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 返回頂部
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 定義價格方案資料
  const pricingPlans = [
    {
      title: '雙邊電梯搬家',
      description: '兩邊都有電梯的搬家服務',
      price: '$3,000'
    },
    {
      title: '無電梯搬家',
      description: '一邊或兩邊無電梯的搬家服務',
      price: '$3,000-5,000'
    },
    {
      title: '廢棄物清運',
      description: '垃圾清運與處理服務',
      price: '$500起'
    },
    {
      title: '人力搬工',
      description: '專業搬運人力支援',
      price: '$1,000/時'
    }
  ];

  const additionalCharges = [
    {
      item: '行軍費',
      price: '500起',
      description: '車輛無法開進巷內需停在比較遠的地方',
      detail: '30公尺加價500、50公尺加價1,000以此類推',
      icon: 'ri-walk-line'
    },
    {
      item: '轉乘電梯',
      price: '1,000',
      description: '有些商場或是大樓設計必須搭乘兩次電梯才可以到達你的住所',
      detail: '',
      icon: 'ri-building-line'
    },
    {
      item: '玄關門太小須拆裝',
      price: '現場為準',
      description: '冰箱或者其他需加工之家具、家電',
      detail: '一般玄關門都是86公分,有些很特殊小於86公分或是玄關門進屋有障礙物',
      icon: 'ri-door-open-line'
    },
    {
      item: '電視尺寸超過55吋',
      price: '1,000 - 1,500',
      description: '電視尺寸越大單價越高',
      detail: '',
      icon: 'ri-tv-line'
    },
    {
      item: '高單價家具',
      price: '現場為準',
      description: '例如:紅木家具、實木家具、藝術品、風水石等等',
      detail: '',
      icon: 'ri-vip-crown-line'
    },
    {
      item: '夜間加成',
      price: '現場為準',
      description: '晚上20:00後夜間加成費用酌收',
      detail: '',
      icon: 'ri-moon-line'
    },
    {
      item: '步行距離',
      price: '依距離計算',
      description: '距離過遠或畸形特殊步行路段另行報價',
      detail: '30公尺+500、40公尺+800、50公尺+1,000',
      icon: 'ri-footprint-line'
    }
  ];

  // 新增：人力搬工費用
  const laborPricing = [
    {
      type: '專業搬運師傅',
      price: '1,000元/時/人',
      description: '最低1小時起算',
      features: ['資深搬運師傅', '家具拆裝', '精緻物品搬運', '專業包裝技術']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Offer Schema - 各項價格方案 */}
      {pricingPlans.map((plan, index) => (
        <SchemaOrg
          key={index}
          type="Offer"
          data={{
            name: plan.title,
            description: plan.description,
            price: plan.price,
            validFrom: '2026-01-01',
            validThrough: '2026-12-31',
            seller: '專業搬家公司'
          }}
        />
      ))}

      {/* Product Schema - 價格方案產品 */}
      {pricingPlans.map((plan, index) => (
        <SchemaOrg
          key={`product-${index}`}
          type="Product"
          data={{
            name: plan.title,
            description: plan.description,
            brand: '專業搬家公司',
            price: plan.price,
            priceValidUntil: '2026-12-31',
            aggregateRating: {
              ratingValue: '4.8',
              reviewCount: '156'
            }
          }}
        />
      ))}

      {/* 右上角導航選單 */}
      <div className="absolute top-8 right-8 flex gap-6 text-sm font-medium z-10">
        <Link 
          to="/"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-home-4-line text-base group-hover:scale-110 transition-transform"></i>
          <span>首頁</span>
        </Link>
        <Link 
          to="/about"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-information-line text-base group-hover:scale-110 transition-transform"></i>
          <span>關於我們</span>
        </Link>
        <Link 
          to="/services"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-service-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務項目</span>
        </Link>
        <Link 
          to="/service-area"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-map-pin-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務範圍</span>
        </Link>
        <Link 
          to="/pricing"
          className="text-teal-600 font-semibold cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-calculator-line text-base group-hover:scale-110 transition-transform"></i>
          <span>搬家費用</span>
        </Link>
        <Link 
          to="/cases"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-gallery-line text-base group-hover:scale-110 transition-transform"></i>
          <span>成功案例</span>
        </Link>
        <Link 
          to="/knowledge"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-book-open-line text-base group-hover:scale-110 transition-transform"></i>
          <span>搬家知識</span>
        </Link>
        <Link 
          to="/faq"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-question-line text-base group-hover:scale-110 transition-transform"></i>
          <span>常見問題</span>
        </Link>
        <Link 
          to="/contact"
          className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-customer-service-line text-base group-hover:scale-110 transition-transform"></i>
          <span>聯絡我們</span>
        </Link>
      </div>

      {/* Hero Section - 優化配色和動畫 */}
      <section className="relative py-20 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-price-tag-3-line text-xl"></i>
              <span className="font-medium">透明公開價格</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              新北台北搬家費用價格表
            </h1>
            <p className="text-xl mb-8 text-white/90 max-w-3xl mx-auto">
              透明公開的價格標準，讓您清楚了解搬家費用、廢棄物清運費用
            </p>
            <div className="flex flex-wrap justify-center gap-3 text-sm">
              <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full font-medium hover:bg-white/30 transition-all cursor-pointer">
                電梯優惠 $3,000 起
              </span>
              <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full font-medium hover:bg-white/30 transition-all cursor-pointer">
                無電梯 $3,000-5,000
              </span>
              <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full font-medium hover:bg-white/30 transition-all cursor-pointer">
                垃圾清運 $500 起
              </span>
              <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full font-medium hover:bg-white/30 transition-all cursor-pointer">
                人力搬工 $1000/時
              </span>
            </div>

            {/* 新增：快速聯絡按鈕 */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:0978900081"
                className="inline-flex items-center justify-center bg-white text-teal-600 px-8 py-3 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                立即來電諮詢
              </a>
              <a 
                href="https://line.me/ti/p/sadiest018moving" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-green-500 text-white px-8 py-3 rounded-full text-lg font-bold hover:bg-green-600 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap border-2 border-white"
              >
                <img 
                  src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                  alt="LINE" 
                  className="w-5 h-5 mr-2"
                />
                LINE 免費估價
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 快速导航 - 優化互動效果 */}
      <section className="py-8 bg-white border-b border-gray-200 sticky top-0 z-20 shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="#moving-price"
              onClick={() => setActiveTab('moving')}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap font-medium transform hover:scale-105 ${
                activeTab === 'moving' 
                  ? 'bg-gradient-to-r from-teal-600 to-emerald-600 text-white shadow-lg' 
                  : 'bg-teal-50 text-teal-700 hover:bg-teal-100'
              }`}
            >
              <i className="ri-truck-line mr-2"></i>搬家費用
            </a>
            <a 
              href="#waste-disposal"
              onClick={() => setActiveTab('waste')}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap font-medium transform hover:scale-105 ${
                activeTab === 'waste' 
                  ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white shadow-lg' 
                  : 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100'
              }`}
            >
              <i className="ri-delete-bin-line mr-2"></i>廢棄物清運
            </a>
            <a 
              href="#labor-price"
              onClick={() => setActiveTab('labor')}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap font-medium transform hover:scale-105 ${
                activeTab === 'labor' 
                  ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg' 
                  : 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100'
              }`}
            >
              <i className="ri-team-line mr-2"></i>人力搬工
            </a>
            <a 
              href="#additional-charges"
              onClick={() => setActiveTab('additional')}
              className={`px-6 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap font-medium transform hover:scale-105 ${
                activeTab === 'additional' 
                  ? 'bg-gradient-to-r from-orange-600 to-amber-600 text-white shadow-lg' 
                  : 'bg-orange-50 text-orange-700 hover:bg-orange-100'
              }`}
            >
              <i className="ri-add-circle-line mr-2"></i>特殊加價
            </a>
          </div>
        </div>
      </section>

      {/* 搬家費用價格表 */}
      <section id="moving-price" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* 價目表主要內容 */}
          <div className="mb-16">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                <i className="ri-truck-line text-teal-600 mr-3"></i>
                新北搬家服務價目表
              </h2>
              <p className="text-lg text-gray-600">以車計價，透明公開</p>
            </div>
            
            {/* 電梯優惠提醒 */}
            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 border-2 border-teal-200 rounded-2xl p-8 mb-8 shadow-lg">
              <div className="flex items-start">
                <div className="bg-teal-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-information-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    🎉 雙邊電梯超值優惠
                  </h3>
                  <p className="text-gray-700 text-lg">
                    此價目表為<strong className="text-teal-700">【無電梯搬運價格】</strong>，如果<strong className="text-teal-700">【兩邊皆有電梯】</strong>一車價格則統一為 
                    <span className="text-teal-600 font-bold text-2xl mx-2">$3,000</span>
                    <span className="text-sm text-gray-600">（市場最優惠價格）</span>
                  </p>
                </div>
              </div>
            </div>

            {/* 價格表格 */}
            <div className="overflow-x-auto mb-8 shadow-2xl rounded-2xl">
              <table className="w-full border-collapse bg-white overflow-hidden">
                <thead>
                  <tr className="bg-gradient-to-r from-teal-600 to-emerald-600">
                    <th className="border border-teal-500 px-6 py-5 text-white font-bold text-lg">樓層數</th>
                    <th className="border border-teal-500 px-6 py-5 text-white font-bold">1樓</th>
                    <th className="border border-teal-500 px-6 py-5 text-white font-bold">2樓</th>
                    <th className="border border-teal-500 px-6 py-5 text-white font-bold">3樓</th>
                    <th className="border border-teal-500 px-6 py-5 text-white font-bold">4樓</th>
                    <th className="border border-teal-500 px-6 py-5 text-white font-bold">5樓</th>
                    <th className="border border-teal-500 px-6 py-5 text-white font-bold">6樓</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="hover:bg-teal-50 transition-colors">
                    <td className="border border-gray-300 px-6 py-4 font-bold bg-teal-50 text-lg">1樓</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors">
                    <td className="border border-gray-300 px-6 py-4 font-bold bg-teal-50 text-lg">2樓</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,300</td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors">
                    <td className="border border-gray-300 px-6 py-4 font-bold bg-teal-50 text-lg">3樓</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,500</td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors">
                    <td className="border border-gray-300 px-6 py-4 font-bold bg-teal-50 text-lg">4樓</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$3,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,500</td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors">
                    <td className="border border-gray-300 px-6 py-4 font-bold bg-teal-50 text-lg">5樓</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,500</td>
                  </tr>
                  <tr className="hover:bg-teal-50 transition-colors">
                    <td className="border border-gray-300 px-6 py-4 font-bold bg-teal-50 text-lg">6樓</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,000</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,300</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$4,500</td>
                    <td className="border border-gray-300 px-6 py-4 text-center text-lg font-semibold">$5,000</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* 範例說明 */}
            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-2xl p-6 mb-8">
              <div className="flex items-start">
                <div className="bg-emerald-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-lightbulb-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">💡 計價範例說明</h4>
                  <p className="text-gray-700">
                    <strong>舉例：</strong>從 3 樓搬到 4 樓，雙方皆無電梯，費用為 <strong className="text-emerald-600 text-xl">$3,500</strong>（參考上方表格交叉點）
                  </p>
                </div>
              </div>
            </div>

            {/* 車輛規格說明 */}
            <div className="bg-gray-50 rounded-2xl p-8 mb-8 border border-gray-200">
              <div className="flex items-start mb-6">
                <div className="bg-teal-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-truck-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">車輛規格說明</h3>
                  <p className="text-gray-600 mt-1">專業 5 噸搬家貨車</p>
                </div>
              </div>
              <div className="ml-16 space-y-4">
                <div className="flex items-start">
                  <span className="text-teal-600 font-bold mr-3 text-lg">★</span>
                  <p className="text-gray-700">
                    一律使用<strong className="text-teal-700">【5噸搬家貨車(舊制3.5噸貨車)】</strong>→ 如有特殊狀況需更換車種會提前告知
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                  <div className="bg-white p-4 rounded-xl border border-gray-200">
                    <div className="text-teal-600 font-bold mb-2">裝運高度</div>
                    <div className="text-2xl font-bold text-gray-900">200cm</div>
                    <div className="text-sm text-gray-600">從地面算起</div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-gray-200">
                    <div className="text-teal-600 font-bold mb-2">車廂容量</div>
                    <div className="text-lg font-bold text-gray-900">高100 × 長300 × 寬160</div>
                    <div className="text-sm text-gray-600">單位：公分</div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-gray-200">
                    <div className="text-teal-600 font-bold mb-2">隨車工具</div>
                    <div className="text-sm text-gray-700">板車、膠膜、籃子、棉被、手工具等</div>
                  </div>
                </div>
              </div>
            </div>

            {/* 重要提醒 */}
            <div className="bg-gradient-to-r from-orange-50 to-amber-50 border-l-4 border-orange-400 p-8 rounded-r-2xl shadow-lg">
              <div className="flex items-start">
                <div className="bg-orange-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-alert-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3">⚠️ 重要提醒</h4>
                  <p className="text-gray-700 mb-3 leading-relaxed">
                    上述參考價格尚未納入<strong className="text-orange-700">【特殊情況】</strong>、<strong className="text-orange-700">【距離】</strong>、<strong className="text-orange-700">【搬運日期】</strong>、<strong className="text-orange-700">【物品特殊性】</strong>、<strong className="text-orange-700">【加購服務】</strong>等會影響價格之因素
                  </p>
                  <p className="text-gray-700">
                    如想了解更多可參考下方費用說明，也可直接來電或 LINE 詢價，<strong className="text-orange-700">實際價格以客服人員報價為主</strong>。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 廢棄物清運費用標準 - 以車計價 */}
      <section id="waste-disposal" className="py-20 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-delete-bin-line text-emerald-600 mr-3"></i>
              廢棄物清運費用標準
            </h2>
            <p className="text-lg text-gray-600">以車計價，清楚透明</p>
          </div>

          {/* 重要說明 */}
          <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-2xl p-8 mb-12 shadow-lg">
            <div className="flex items-start">
              <div className="bg-emerald-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  🚛 廢棄物清運計價說明
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-emerald-600 mr-2 mt-1"></i>
                    <span><strong className="text-emerald-700">以車計價</strong>，依照車輛大小和裝載量收費</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-emerald-600 mr-2 mt-1"></i>
                    <span>價格<strong className="text-emerald-700">含搬運、清運及環保處理費用</strong></span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-emerald-600 mr-2 mt-1"></i>
                    <span>可回收物品（家電、金屬等）可<strong className="text-emerald-700">折抵部分費用</strong></span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-emerald-600 mr-2 mt-1"></i>
                    <span>搬家同時清運廢棄物可享<strong className="text-emerald-700">組合優惠</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* 車輛計價表 */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* 小型貨車 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-gray-200 hover:border-emerald-400 transition-all hover:shadow-2xl hover:scale-105">
              <div className="bg-gradient-to-br from-emerald-400 to-teal-400 px-6 py-8 text-center">
                <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-white text-4xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">小型貨車</h3>
                <div className="text-sm text-emerald-50 mb-4">1.5噸 / 約2坪空間</div>
                <div className="bg-white/20 rounded-xl p-4 backdrop-blur-sm">
                  <div className="text-4xl font-bold text-white mb-1">$3,000</div>
                  <div className="text-emerald-50 text-sm">起/車</div>
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">車廂尺寸</div>
                  <div className="text-gray-600">長 250cm × 寬 130cm × 高 130cm</div>
                </div>
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">適用情況</div>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>套房、小坪數廢棄物</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>少量家具家電清運</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>裝潢後小量廢料</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>辦公室小型清運</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-emerald-50 rounded-xl p-3">
                  <div className="text-xs text-emerald-700 font-medium">
                    💡 約可裝載：單人沙發、小型衣櫃、書桌、床墊等 3-5 件家具
                  </div>
                </div>
              </div>
            </div>

            {/* 中型貨車 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-emerald-400 hover:border-emerald-500 transition-all hover:shadow-2xl hover:scale-105 relative">
              <div className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold z-10">
                最熱門
              </div>
              <div className="bg-gradient-to-br from-emerald-500 to-teal-500 px-6 py-8 text-center">
                <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-white text-4xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">中型貨車</h3>
                <div className="text-sm text-emerald-50 mb-4">3.5噸 / 約4坪空間</div>
                <div className="bg-white/20 rounded-xl p-4 backdrop-blur-sm">
                  <div className="text-4xl font-bold text-white mb-1">$5,000</div>
                  <div className="text-emerald-50 text-sm">起/車</div>
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">車廂尺寸</div>
                  <div className="text-gray-600">長 300cm × 寬 160cm × 高 160cm</div>
                </div>
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">適用情況</div>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>一般家庭廢棄物清運</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>中型家具家電處理</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>裝潢廢料清運</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>辦公室整理清運</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-emerald-50 rounded-xl p-3">
                  <div className="text-xs text-emerald-700 font-medium">
                    💡 約可裝載：雙人沙發、大型衣櫃、冰箱、洗衣機等 8-12 件家具
                  </div>
                </div>
              </div>
            </div>

            {/* 大型貨車 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-gray-200 hover:border-emerald-400 transition-all hover:shadow-2xl hover:scale-105">
              <div className="bg-gradient-to-br from-emerald-600 to-teal-600 px-6 py-8 text-center">
                <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-white text-4xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">大型貨車</h3>
                <div className="text-sm text-emerald-50 mb-4">5噸 / 約6坪空間</div>
                <div className="bg-white/20 rounded-xl p-4 backdrop-blur-sm">
                  <div className="text-4xl font-bold text-white mb-1">$7,000</div>
                  <div className="text-emerald-50 text-sm">起/車</div>
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">車廂尺寸</div>
                  <div className="text-gray-600">長 400cm × 寬 180cm × 高 180cm</div>
                </div>
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">適用情況</div>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>大量家庭廢棄物</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>整屋家具清空</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>大型裝潢廢料</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-emerald-600 mr-2 mt-0.5"></i>
                      <span>商業空間清運</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-emerald-50 rounded-xl p-3">
                  <div className="text-xs text-emerald-700 font-medium">
                    💡 約可裝載：整套客廳家具、多件大型家電、床組等 15-20 件家具
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 常見廢棄物清運項目參考 */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-12 border border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-list-check text-emerald-600 mr-3"></i>
              常見廢棄物清運項目參考
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-sofa-line text-emerald-600 mr-2"></i>
                  家具類
                </h4>
                <ul className="space-y-2 text-gray-600 text-sm">
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>沙發（單人/雙人/三人）</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>床墊、床架、床組</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>衣櫃、書櫃、鞋櫃</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>餐桌、書桌、茶几</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>椅子、櫃子、層架</span>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-tv-line text-emerald-600 mr-2"></i>
                  家電類
                </h4>
                <ul className="space-y-2 text-gray-600 text-sm">
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>冰箱、洗衣機、烘衣機</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>電視、冷氣、除濕機</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>微波爐、烤箱、熱水器</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>電風扇、空氣清淨機</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>其他小型家電</span>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-hammer-line text-emerald-600 mr-2"></i>
                  裝潢廢料
                </h4>
                <ul className="space-y-2 text-gray-600 text-sm">
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>木材、木板、木櫃</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>磁磚、水泥、石材</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>塑膠、金屬、玻璃</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>門窗、天花板、地板</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>混合裝潢廢料</span>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-delete-bin-line text-emerald-600 mr-2"></i>
                  其他廢棄物
                </h4>
                <ul className="space-y-2 text-gray-600 text-sm">
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>一般家庭垃圾</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>書籍、紙類、紙箱</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>舊衣物、布料、棉被</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>玩具、雜物、擺飾</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-emerald-600 mr-2">•</span>
                    <span>辦公用品、文件</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* 特殊說明 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border-2 border-green-200">
              <div className="flex items-start">
                <div className="bg-green-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-recycle-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">♻️ 可回收物品優惠</h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>冰箱、洗衣機、冷氣等大型家電可折抵 $300-800</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>金屬類廢料可依重量折抵費用</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>大量紙類、書籍可免費或優惠處理</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>舊衣物可協助捐贈，免收清運費</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 border-2 border-orange-200">
              <div className="flex items-start">
                <div className="bg-orange-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-alert-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">⚠️ 特殊廢棄物說明</h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>危險廢棄物（化學品、油漆等）需現場評估</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>大型鋼琴、保險櫃等特殊物品另計</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>超過車輛載重需加派車輛</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>樓層過高或無電梯可能加收搬運費</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* 組合優惠 */}
          <div className="mt-12 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-2xl p-8 text-center shadow-2xl">
            <h3 className="text-2xl font-bold text-white mb-4">
              🎁 搬家 + 廢棄物清運組合優惠
            </h3>
            <p className="text-teal-50 text-lg mb-6">
              搬家同時清運廢棄物，享有特別優惠價格！
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:0978900081"
                className="inline-flex items-center justify-center bg-white text-teal-600 px-8 py-3 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                立即來電諮詢
              </a>
              <a 
                href="https://line.me/ti/p/sadiest018moving" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-green-500 text-white px-8 py-3 rounded-full text-lg font-bold hover:bg-green-600 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap border-2 border-white"
              >
                <img 
                  src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                  alt="LINE" 
                  className="w-5 h-5 mr-2"
                />
                LINE 免費估價
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 人力搬工費用 */}
      <section id="labor-price" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-team-line text-indigo-600 mr-3"></i>
              人力搬工費用標準
            </h2>
            <p className="text-lg text-gray-600">以小時計費，一小時費用 1,000 元</p>
          </div>

          {/* 重要說明 */}
          <div className="bg-gradient-to-r from-indigo-50 to-purple-50 border-2 border-indigo-200 rounded-2xl p-8 mb-12 shadow-lg">
            <div className="flex items-start">
              <div className="bg-indigo-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  👷 人力搬工計價說明
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-indigo-600 mr-2 mt-1"></i>
                    <span><strong className="text-indigo-700">以小時計費</strong>，一小時費用 1,000 元</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-indigo-600 mr-2 mt-1"></i>
                    <span>所有人力皆為<strong className="text-indigo-700">專業訓練搬運人員</strong></span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-indigo-600 mr-2 mt-1"></i>
                    <span>可依需求<strong className="text-indigo-700">彈性調配人力數量</strong></span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-indigo-600 mr-2 mt-1"></i>
                    <span>搬家服務已含基本人力，<strong className="text-indigo-700">額外人力另計</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* 人力計價方案 */}
          <div className="max-w-2xl mx-auto mb-12">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-indigo-400 hover:shadow-2xl hover:scale-105 transition-all">
              <div className="bg-gradient-to-br from-indigo-500 to-purple-500 px-6 py-8 text-center">
                <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-star-line text-white text-4xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">專業搬運師傅</h3>
                <div className="text-sm text-indigo-50 mb-4">資深專業人員</div>
                <div className="bg-white/20 rounded-xl p-4 backdrop-blur-sm">
                  <div className="text-4xl font-bold text-white mb-1">$1,000</div>
                  <div className="text-indigo-50 text-sm">每小時/每人</div>
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">計費方式</div>
                  <div className="text-gray-600">最低 1 小時起算，超過以半小時為單位計算</div>
                </div>
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">服務內容</div>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-indigo-600 mr-2 mt-0.5"></i>
                      <span>大型家具搬運</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-indigo-600 mr-2 mt-0.5"></i>
                      <span>家具拆裝服務</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-indigo-600 mr-2 mt-0.5"></i>
                      <span>精緻物品包裝</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-line text-indigo-600 mr-2 mt-0.5"></i>
                      <span>專業搬運技術</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-indigo-50 rounded-xl p-3">
                  <div className="text-xs text-indigo-700 font-medium">
                    💡 適合：大型家具、精緻物品、需要拆裝服務
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 計費範例說明 */}
          <div className="bg-gradient-to-r from-purple-50 to-indigo-50 border-2 border-purple-200 rounded-2xl p-8 mb-12">
            <div className="flex items-start">
              <div className="bg-purple-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                <i className="ri-calculator-line text-white text-xl"></i>
              </div>
              <div className="flex-1">
                <h4 className="text-xl font-bold text-gray-900 mb-4">💡 計費範例說明</h4>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <h5 className="font-bold text-gray-800 mb-3 flex items-center">
                      <i className="ri-time-line text-indigo-600 mr-2"></i>
                      範例一：3 小時搬運
                    </h5>
                    <div className="space-y-2 text-sm text-gray-700">
                      <div className="flex justify-between">
                        <span>工作時間：</span>
                        <strong>3 小時</strong>
                      </div>
                      <div className="flex justify-between">
                        <span>人力需求：</span>
                        <strong>2 人</strong>
                      </div>
                      <div className="flex justify-between">
                        <span>時薪：</span>
                        <strong>$1,000/時/人</strong>
                      </div>
                      <div className="border-t border-gray-200 pt-2 mt-2 flex justify-between text-base">
                        <span className="font-bold">總費用：</span>
                        <strong className="text-indigo-600 text-xl">$6,000</strong>
                      </div>
                      <div className="text-xs text-gray-500 italic">
                        計算：$1,000 × 3小時 × 2人 = $6,000
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <h5 className="font-bold text-gray-800 mb-3 flex items-center">
                      <i className="ri-time-line text-indigo-600 mr-2"></i>
                      範例二：4 小時搬運
                    </h5>
                    <div className="space-y-2 text-sm text-gray-700">
                      <div className="flex justify-between">
                        <span>工作時間：</span>
                        <strong>4 小時</strong>
                      </div>
                      <div className="flex justify-between">
                        <span>人力需求：</span>
                        <strong>2 人</strong>
                      </div>
                      <div className="flex justify-between">
                        <span>時薪：</span>
                        <strong>$1,000/時/人</strong>
                      </div>
                      <div className="border-t border-gray-200 pt-2 mt-2 flex justify-between text-base">
                        <span className="font-bold">總費用：</span>
                        <strong className="text-indigo-600 text-xl">$8,000</strong>
                      </div>
                      <div className="text-xs text-gray-500 italic">
                        計算：$1,000 × 4小時 × 2人 = $8,000
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 特殊說明 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border-2 border-green-200">
              <div className="flex items-start">
                <div className="bg-green-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">✅ 服務包含</h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>專業搬運人員</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>基本搬運工具</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>樓層搬運服務</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                      <span>基本包裝材料</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 border-2 border-orange-200">
              <div className="flex items-start">
                <div className="bg-orange-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                  <i className="ri-alert-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">⚠️ 注意事項</h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>最低 1 小時起算</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>超過以半小時為單位</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>特殊物品需現場評估</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>夜間時段可能加價</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* CTA 區域 */}
          <div className="mt-12 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl p-8 text-center shadow-2xl">
            <h3 className="text-2xl font-bold text-white mb-4">
              💪 需要額外人力協助嗎？
            </h3>
            <p className="text-indigo-50 text-lg mb-6">
              立即聯繫我們，專業團隊為您服務！
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:0978900081"
                className="inline-flex items-center justify-center bg-white text-indigo-600 px-8 py-3 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                立即來電諮詢
              </a>
              <a 
                href="https://line.me/ti/p/sadiest018moving" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-green-500 text-white px-8 py-3 rounded-full text-lg font-bold hover:bg-green-600 transition-all shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap border-2 border-white"
              >
                <img 
                  src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                  alt="LINE" 
                  className="w-5 h-5 mr-2"
                />
                LINE 免費估價
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 特殊狀況加價標準 */}
      <section id="additional-charges" className="py-20 bg-gradient-to-br from-orange-50 via-white to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-add-circle-line text-orange-600 mr-3"></i>
              特殊狀況加價標準
            </h2>
            <p className="text-lg text-gray-600">現場評估，透明告知</p>
          </div>

          <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-2 border-amber-200 rounded-2xl p-8 mb-8">
            <div className="flex items-start">
              <div className="bg-amber-500 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">🔔 重要提醒</h4>
                <p className="text-gray-700 text-lg">
                  搬家現場評估時所需注意到的特殊狀況、加價金額，現場評估同時都會一併告知，<strong className="text-orange-700">避免事後加價之狀況發生</strong>
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {additionalCharges.map((charge, index) => (
              <div key={index} className="bg-white border-2 border-gray-200 rounded-2xl p-6 hover:shadow-xl transition-all hover:border-orange-300">
                <div className="flex items-start mb-4">
                  <div className="bg-orange-100 p-3 rounded-full mr-4 flex-shrink-0 w-12 h-12 flex items-center justify-center">
                    <i className={`${charge.icon} text-orange-600 text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-start mb-2">
                      <h4 className="text-xl font-bold text-gray-900">{charge.item}</h4>
                      <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap ml-2">
                        {charge.price}
                      </span>
                    </div>
                    <p className="text-gray-600 mb-2 leading-relaxed">{charge.description}</p>
                    {charge.detail && (
                      <p className="text-sm text-gray-500 italic bg-gray-50 p-3 rounded-lg">{charge.detail}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 價格優勢 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-12 shadow-xl border border-teal-200">
            <h3 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              💎 建鈞搬家價格優勢
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center bg-white rounded-2xl p-8 shadow-lg">
                <div className="bg-gradient-to-br from-teal-500 to-emerald-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className="ri-price-tag-3-line text-white text-3xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">透明收費</h4>
                <p className="text-gray-600 leading-relaxed">
                  明確報價，絕無隱藏費用，所有加價項目現場告知，讓您消費安心
                </p>
              </div>
              <div className="text-center bg-white rounded-2xl p-8 shadow-lg">
                <div className="bg-gradient-to-br from-indigo-500 to-purple-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className="ri-calculator-line text-white text-3xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">免費評估</h4>
                <p className="text-gray-600 leading-relaxed">
                  提供免費現場評估，專業顧問給您最準確的報價，24 小時快速回覆
                </p>
              </div>
              <div className="text-center bg-white rounded-2xl p-8 shadow-lg">
                <div className="bg-gradient-to-br from-orange-500 to-amber-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className="ri-money-dollar-circle-line text-white text-3xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">合理價格</h4>
                <p className="text-gray-600 leading-relaxed">
                  價格公道合理，與市場行情相符，提供最優質的性價比服務
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quote CTA */}
      <section className="py-16 bg-gradient-to-br from-teal-500 via-emerald-500 to-teal-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">需要詳細報價？</h2>
          <p className="text-xl text-teal-50 mb-8">
            每個搬家案例都有其特殊性，歡迎直接聯繫我們免費諮詢估價
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081"
              className="inline-flex items-center justify-center bg-white text-teal-600 px-10 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-3 text-xl"></i>
              0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/sadiest018moving" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-green-500 text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-green-600 transition-all shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap border-2 border-white"
            >
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                alt="LINE" 
                className="w-6 h-6 mr-3"
              />
              官方 LINE 免費估價
            </a>
          </div>
          <p className="text-teal-50 mt-6 text-sm">
            ⏰ 24 小時快速回覆 | 📱 傳送照片更精準估價 | 🎯 專業顧問免費諮詢
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            <i className="ri-question-line text-teal-600 mr-3"></i>
            常見問題
          </h2>
          <div className="space-y-6">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-question-line text-teal-600 mr-3"></i>
                如何計算搬家費用？
              </h4>
              <p className="text-gray-600 leading-relaxed">
                搬家費用會根據搬運距離、樓層、物品數量、特殊狀況等因素綜合計算。我們提供免費現場評估，給您最準確的報價。基本費用為雙邊電梯 $3,000 起，無電梯依樓層 $3,000-5,000。
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-question-line text-teal-600 mr-3"></i>
                人力搬工怎麼計算？
              </h4>
              <p className="text-gray-600 leading-relaxed">
                人力搬工提供時薪制和包工制。基本人力 $800/時/人（最低 2 小時），專業師傅 $1,000/時/人。半日包工 $3,500/人（4 小時），全日包工 $6,000/人（8 小時）。包工制更划算。
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-question-line text-teal-600 mr-3"></i>
                付款方式有哪些？
              </h4>
              <p className="text-gray-600 leading-relaxed">
                我們接受現金、轉帳等多種付款方式，詳細付款資訊會在報價時一併說明。一般為服務完成後付款，大型搬家可能需要預付訂金。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 返回頂部按鈕 */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-24 right-8 bg-gradient-to-r from-teal-600 to-emerald-600 text-white w-12 h-12 rounded-full shadow-2xl hover:shadow-3xl transition-all hover:scale-110 z-50 flex items-center justify-center cursor-pointer"
          aria-label="返回頂部"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
        </button>
      )}

      {/* 浮動 LINE 按鈕 */}
      <a
        href="https://line.me/ti/p/sadiest018moving"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 bg-green-500 text-white w-14 h-14 rounded-full shadow-2xl hover:shadow-3xl transition-all hover:scale-110 z-50 flex items-center justify-center cursor-pointer group"
        aria-label="LINE 諮詢"
      >
        <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-75"></div>
        <img 
          src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
          alt="LINE" 
          className="w-8 h-8 relative z-10"
        />
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          LINE 免費估價
        </span>
      </a>
    </div>
  );
};

export default PricingPage;